import _ from "lodash";
export const getStudentFeedQueryVariables = params => {
  return params;
};

export const getStudentFeedQueryVariablesMemoized = _.memoize(
  params => getStudentFeedQueryVariables(params),
  params => JSON.stringify(params)
);
